module.exports = __webpack_public_path__ + "static/media/app-logo.8cc65ef2.png";